import { useNavigate } from 'react-router-dom'
import { LineChart, Vars } from '@carrent/ui'

/** Гаджет: Задачи команды. */

export function TeamTasksWidget({ data }) {
  const navigate = useNavigate()
  const { counts, people, flow } = data

  if (!counts.open && !flow.length) {
    return <p className="widget-empty">Открытых задач нет</p>
  }

  const maxOpen = Math.max(...people.map((p) => p.open), 1)

  return (
    <div className="team-tasks">
      <div className="team-tasks__summary">
        <button
          type="button"
          className="chip"
          onClick={() => navigate('/admin/tasks')}
        >
          {counts.open} открытых
        </button>
        {counts.overdue > 0 && (
          <span className="chip chip--danger">{counts.overdue} просрочено</span>
        )}
        {counts.unassigned > 0 && (
          <span className="chip chip--warning">{counts.unassigned} без исполнителя</span>
        )}
      </div>

      {flow.length > 1 && (
        <div className="team-tasks__flow">
          <span className="team-tasks__flow-label">Создано против закрытого</span>
          <LineChart
            data={flow}
            valueKey="created"
            color="var(--warning)"
            label="Создано задач по дням"
          />
          <LineChart
            data={flow}
            valueKey="completed"
            color="var(--success)"
            label="Закрыто задач по дням"
          />
        </div>
      )}

      <ul className="widget-list">
        {people.map((p) => (
          <li key={p.user_id}>
            <button
              type="button"
              className="ranking__row"
              onClick={() => navigate(`/admin/users/${p.user_id}`)}
            >
              <span className="ranking__name">{p.name}</span>
              <span className="ranking__track">
                <Vars
                  as="span"
                  className="ranking__bar"
                  vars={{ '--bar-w': `${(p.open / maxOpen) * 100}%` }}
                />
              </span>
              <span className="ranking__value">
                {p.open}
                {p.overdue > 0 && <span className="ranking__overdue">{p.overdue}</span>}
              </span>
            </button>
          </li>
        ))}
      </ul>
    </div>
  )
}
